import React from 'react'
import { getFieldsForCard, IDetailFields } from 'core/components/InfoPanel'
import { makeStyles } from '@material-ui/styles'
import { ImportedClusterSelector } from 'app/plugins/infrastructure/components/importedClusters/model'
import Theme from 'core/themes/model'
import renderLabels from 'k8s/components/pods/renderLabels'
import InfoCard from 'k8s/components/common/entity/info-card'
import Card from 'core/elements/card'

const renderBoolean = (bool) => (bool ? 'True' : 'False')

const renderStringArray = (array = []) => array.join(', ')

const clusterOverviewFields: Array<IDetailFields<ImportedClusterSelector>> = [
  { id: 'spec.aks.type', title: 'Type' },
  { id: 'spec.aks.kubernetesVersion', title: 'KubernetesVersion' },
  { id: 'spec.aks.fqdn', title: 'FQDN' },
  { id: 'spec.aks.enableRBAC', title: 'Enabled RBAC', render: renderBoolean },
  { id: 'spec.aks.maxAgentPools', title: 'Max Agent Pools' },
  // { id: 'spec.aks.enablePrivateCluster', title: 'Enable Private Cluster' },
  { id: 'spec.aks.nodeResourceGroup', title: 'Node Resource Group' },
  { id: 'spec.aks.dnsPrefix', title: 'DNS Prefix' },
]

const networkingFields: Array<IDetailFields<ImportedClusterSelector>> = [
  { id: 'spec.aks.network.plugin', title: 'Plugin' },
  { id: 'spec.aks.network.policy', title: 'Policy' },
  { id: 'spec.aks.network.serviceCIDR', title: 'Service CIDR' },
  { id: 'spec.aks.network.containerCIDR', title: 'Container CIDR' },
  { id: 'spec.aks.network.dnsServiceIP', title: 'DNS Service IP' },
  { id: 'spec.aks.network.outboundType', title: 'Outbound Type' },
  { id: 'spec.aks.network.loadBalancerProfile.managedOutboundIPs', title: 'Managed Outbound IPs' },
  // { id: 'spec.aks.network.loadBalancerProfile.outboundIPs', title: 'Outbound IPs' },
  // { id: 'spec.aks.network.outboundIPPrefixes', title: 'Outbound IP Prefixes' },
  // { id: 'spec.aks.network.allocatedOutboundPorts', title: 'Allocated Outbound Ports' },
  // {
  //   id: 'spec.eks.network.vpc.subnets',
  //   title: 'Subnets',
  //   render: (subnets) => subnets.map((net) => <div>{net}</div>),
  // },
]

const loadBalancerFields: Array<IDetailFields<ImportedClusterSelector>> = [
  {
    id: 'spec.aks.network.loadBalancerSKU',
    title: 'Load Balancer SKU',
  },
  {
    id: 'spec.aks.network.loadBalancerProfile.effectiveOutboundIPs',
    title: 'Effective Outbound IPs',
    render: renderStringArray,
  },
]

interface Props {
  cluster: ImportedClusterSelector
  loading: boolean
  reload: any
}
const AksDetails = ({ cluster, loading, reload }: Props) => {
  const classes = useStyles({})
  const overview = getFieldsForCard(clusterOverviewFields, cluster)
  const networking = getFieldsForCard(networkingFields, cluster)
  const loadBalancer = getFieldsForCard(loadBalancerFields, cluster)

  return (
    <div className={classes.clusterInfo}>
      <InfoCard className={classes.overview} title="Overview" items={overview} />
      <InfoCard className={classes.networking} title="Networking" items={networking} />
      <InfoCard className={classes.loadBalancer} title="Load Balancer" items={loadBalancer} />
      {cluster?.spec?.aks?.tags && (
        <Card className={classes.tags} title="Tags">
          {renderLabels()(cluster?.spec?.aks?.tags)}
        </Card>
      )}
    </div>
  )
}

export default AksDetails

const useStyles = makeStyles<Theme>((theme) => ({
  clusterInfo: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gridTemplateRows: 'max-content max-content',
    gridGap: '16px',
    alignItems: 'stretch',
    justifyItems: 'start',
    marginTop: theme.spacing(2),
    maxWidth: 1100,
    gridTemplateAreas: `
    "overview  networking"
    "loadBalancer tags "
    `,
  },
  overview: {
    gridArea: 'overview',
  },
  networking: {
    gridArea: 'networking',
  },
  loadBalancer: {
    gridArea: 'loadBalancer',
    width: '100%',
  },
  tags: {
    gridArea: 'tags',
    width: '100%',
  },
}))
